import { useSelector } from "react-redux";
import { CartOptional } from "../interfaces/Cart";
import { StoreState } from "../interfaces/storeState";

export const useCartSelectionsOptional = (): CartOptional =>
  useSelector(getCartSelectionsOptional);

const getCartSelectionsOptional = (state: StoreState): CartOptional => {
  if (!state.cartSelections?.optional) {
    return undefined;
  }

  return state.cartSelections.optional;
};
